var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFluentEmojiEvergreenTree(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fluent-emoji:evergreen-tree"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.9798 28.5923H12.0641C11.5616 28.5923 11.1801 28.0223 11.2907 27.4279L11.7726 24.8433H18.2723L18.7551 27.4279C18.8554 28.0223 18.4832 28.5933 17.9816 28.5933L17.9798 28.5923Z",
    fill: "#795556"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.9798 28.5923H12.0641C11.5616 28.5923 11.1801 28.0223 11.2907 27.4279L11.7726 24.8433H18.2723L18.7551 27.4279C18.8554 28.0223 18.4832 28.5933 17.9816 28.5933L17.9798 28.5923Z",
    fill: "url(#paint0_radial_434_3301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.9798 28.5923H12.0641C11.5616 28.5923 11.1801 28.0223 11.2907 27.4279L11.7726 24.8433H18.2723L18.7551 27.4279C18.8554 28.0223 18.4832 28.5933 17.9816 28.5933L17.9798 28.5923Z",
    fill: "url(#paint1_radial_434_3301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.9798 28.5923H12.0641C11.5616 28.5923 11.1801 28.0223 11.2907 27.4279L11.7726 24.8433H18.2723L18.7551 27.4279C18.8554 28.0223 18.4832 28.5933 17.9816 28.5933L17.9798 28.5923Z",
    fill: "url(#paint2_linear_434_3301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M17.9798 28.5923H12.0641C11.5616 28.5923 11.1801 28.0223 11.2907 27.4279L11.7726 24.8433H18.2723L18.7551 27.4279C18.8554 28.0223 18.4832 28.5933 17.9816 28.5933L17.9798 28.5923Z",
    fill: "url(#paint3_linear_434_3301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M17.9798 28.5923H12.0641C11.5616 28.5923 11.1801 28.0223 11.2907 27.4279L11.7726 24.8433H18.2723L18.7551 27.4279C18.8554 28.0223 18.4832 28.5933 17.9816 28.5933L17.9798 28.5923Z",
    fill: "url(#paint4_linear_434_3301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M17.9798 28.5923H12.0641C11.5616 28.5923 11.1801 28.0223 11.2907 27.4279L11.7726 24.8433H18.2723L18.7551 27.4279C18.8554 28.0223 18.4832 28.5933 17.9816 28.5933L17.9798 28.5923Z",
    fill: "url(#paint5_linear_434_3301)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    filter: "url(#filter0_i_434_3301)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M11.6035 18.5593H18.4379C20.3973 18.5593 21.1913 18.8434 22.2207 19.9356C22.8582 20.695 23.4807 21.5106 23.4076 23.0125C23.3195 24.8134 22.2798 25.7218 20.1263 25.7218H9.91602C7.76259 25.7218 6.7229 24.8134 6.63477 23.0125C6.56165 21.5115 7.18415 20.695 7.82165 19.9356C8.85102 18.8434 9.64509 18.5593 11.6035 18.5593Z",
    fill: "url(#paint6_radial_434_3301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M11.6035 18.5593H18.4379C20.3973 18.5593 21.1913 18.8434 22.2207 19.9356C22.8582 20.695 23.4807 21.5106 23.4076 23.0125C23.3195 24.8134 22.2798 25.7218 20.1263 25.7218H9.91602C7.76259 25.7218 6.7229 24.8134 6.63477 23.0125C6.56165 21.5115 7.18415 20.695 7.82165 19.9356C8.85102 18.8434 9.64509 18.5593 11.6035 18.5593Z",
    fill: "url(#paint7_radial_434_3301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M11.6035 18.5593H18.4379C20.3973 18.5593 21.1913 18.8434 22.2207 19.9356C22.8582 20.695 23.4807 21.5106 23.4076 23.0125C23.3195 24.8134 22.2798 25.7218 20.1263 25.7218H9.91602C7.76259 25.7218 6.7229 24.8134 6.63477 23.0125C6.56165 21.5115 7.18415 20.695 7.82165 19.9356C8.85102 18.8434 9.64509 18.5593 11.6035 18.5593Z",
    fill: "url(#paint8_radial_434_3301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M11.6035 18.5593H18.4379C20.3973 18.5593 21.1913 18.8434 22.2207 19.9356C22.8582 20.695 23.4807 21.5106 23.4076 23.0125C23.3195 24.8134 22.2798 25.7218 20.1263 25.7218H9.91602C7.76259 25.7218 6.7229 24.8134 6.63477 23.0125C6.56165 21.5115 7.18415 20.695 7.82165 19.9356C8.85102 18.8434 9.64509 18.5593 11.6035 18.5593Z",
    fill: "url(#paint9_linear_434_3301)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M11.6035 18.5593H18.4379C20.3973 18.5593 21.1913 18.8434 22.2207 19.9356C22.8582 20.695 23.4807 21.5106 23.4076 23.0125C23.3195 24.8134 22.2798 25.7218 20.1263 25.7218H9.91602C7.76259 25.7218 6.7229 24.8134 6.63477 23.0125C6.56165 21.5115 7.18415 20.695 7.82165 19.9356C8.85102 18.8434 9.64509 18.5593 11.6035 18.5593Z",
    fill: "url(#paint10_radial_434_3301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M12.7953 13.4463C11.8615 13.4463 11.0609 13.7725 10.3915 14.5525L10.3128 14.6557C9.91808 15.1666 9.49151 15.7207 9.33683 16.7022C9.2712 17.951 9.88339 18.5585 10.9184 18.5585H19.0934C20.1284 18.5585 20.7406 17.951 20.675 16.7022C20.5203 15.7207 20.0937 15.1666 19.699 14.6547C19.6727 14.6207 19.6464 14.5867 19.6203 14.5525C18.95 13.7725 18.1503 13.4463 17.2165 13.4463H12.7953Z",
    fill: "url(#paint11_radial_434_3301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M12.7953 13.4463C11.8615 13.4463 11.0609 13.7725 10.3915 14.5525L10.3128 14.6557C9.91808 15.1666 9.49151 15.7207 9.33683 16.7022C9.2712 17.951 9.88339 18.5585 10.9184 18.5585H19.0934C20.1284 18.5585 20.7406 17.951 20.675 16.7022C20.5203 15.7207 20.0937 15.1666 19.699 14.6547C19.6727 14.6207 19.6464 14.5867 19.6203 14.5525C18.95 13.7725 18.1503 13.4463 17.2165 13.4463H12.7953Z",
    fill: "url(#paint12_linear_434_3301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M12.7953 13.4463C11.8615 13.4463 11.0609 13.7725 10.3915 14.5525L10.3128 14.6557C9.91808 15.1666 9.49151 15.7207 9.33683 16.7022C9.2712 17.951 9.88339 18.5585 10.9184 18.5585H19.0934C20.1284 18.5585 20.7406 17.951 20.675 16.7022C20.5203 15.7207 20.0937 15.1666 19.699 14.6547C19.6727 14.6207 19.6464 14.5867 19.6203 14.5525C18.95 13.7725 18.1503 13.4463 17.2165 13.4463H12.7953Z",
    fill: "url(#paint13_radial_434_3301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M12.7953 13.4463C11.8615 13.4463 11.0609 13.7725 10.3915 14.5525L10.3128 14.6557C9.91808 15.1666 9.49151 15.7207 9.33683 16.7022C9.2712 17.951 9.88339 18.5585 10.9184 18.5585H19.0934C20.1284 18.5585 20.7406 17.951 20.675 16.7022C20.5203 15.7207 20.0937 15.1666 19.699 14.6547C19.6727 14.6207 19.6464 14.5867 19.6203 14.5525C18.95 13.7725 18.1503 13.4463 17.2165 13.4463H12.7953Z",
    fill: "url(#paint14_radial_434_3301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M12.7953 13.4463C11.8615 13.4463 11.0609 13.7725 10.3915 14.5525L10.3128 14.6557C9.91808 15.1666 9.49151 15.7207 9.33683 16.7022C9.2712 17.951 9.88339 18.5585 10.9184 18.5585H19.0934C20.1284 18.5585 20.7406 17.951 20.675 16.7022C20.5203 15.7207 20.0937 15.1666 19.699 14.6547C19.6727 14.6207 19.6464 14.5867 19.6203 14.5525C18.95 13.7725 18.1503 13.4463 17.2165 13.4463H12.7953Z",
    fill: "url(#paint15_radial_434_3301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M12.7953 13.4463C11.8615 13.4463 11.0609 13.7725 10.3915 14.5525L10.3128 14.6557C9.91808 15.1666 9.49151 15.7207 9.33683 16.7022C9.2712 17.951 9.88339 18.5585 10.9184 18.5585H19.0934C20.1284 18.5585 20.7406 17.951 20.675 16.7022C20.5203 15.7207 20.0937 15.1666 19.699 14.6547C19.6727 14.6207 19.6464 14.5867 19.6203 14.5525C18.95 13.7725 18.1503 13.4463 17.2165 13.4463H12.7953Z",
    fill: "url(#paint16_radial_434_3301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M12.7953 13.4463C11.8615 13.4463 11.0609 13.7725 10.3915 14.5525L10.3128 14.6557C9.91808 15.1666 9.49151 15.7207 9.33683 16.7022C9.2712 17.951 9.88339 18.5585 10.9184 18.5585H19.0934C20.1284 18.5585 20.7406 17.951 20.675 16.7022C20.5203 15.7207 20.0937 15.1666 19.699 14.6547C19.6727 14.6207 19.6464 14.5867 19.6203 14.5525C18.95 13.7725 18.1503 13.4463 17.2165 13.4463H12.7953Z",
    fill: "url(#paint17_radial_434_3301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M13.7879 7.2258C13.9091 7.00486 14.0875 6.82056 14.3044 6.69219C14.5213 6.56382 14.7687 6.49609 15.0207 6.49609C15.2727 6.49609 15.5201 6.56382 15.737 6.69219C15.9539 6.82056 16.1322 7.00486 16.2535 7.2258L18.6779 11.6414C18.7799 11.827 18.8317 12.036 18.8283 12.2478C18.8249 12.4596 18.7664 12.6668 18.6585 12.8491C18.5506 13.0313 18.3971 13.1823 18.2131 13.2872C18.0291 13.3921 17.8209 13.4472 17.6091 13.447H12.4322C12.2205 13.4472 12.0123 13.3921 11.8283 13.2872C11.6442 13.1823 11.4907 13.0313 11.3828 12.8491C11.275 12.6668 11.2164 12.4596 11.213 12.2478C11.2097 12.036 11.2615 11.827 11.3635 11.6414L13.7879 7.2258Z",
    fill: "url(#paint18_linear_434_3301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M13.7879 7.2258C13.9091 7.00486 14.0875 6.82056 14.3044 6.69219C14.5213 6.56382 14.7687 6.49609 15.0207 6.49609C15.2727 6.49609 15.5201 6.56382 15.737 6.69219C15.9539 6.82056 16.1322 7.00486 16.2535 7.2258L18.6779 11.6414C18.7799 11.827 18.8317 12.036 18.8283 12.2478C18.8249 12.4596 18.7664 12.6668 18.6585 12.8491C18.5506 13.0313 18.3971 13.1823 18.2131 13.2872C18.0291 13.3921 17.8209 13.4472 17.6091 13.447H12.4322C12.2205 13.4472 12.0123 13.3921 11.8283 13.2872C11.6442 13.1823 11.4907 13.0313 11.3828 12.8491C11.275 12.6668 11.2164 12.4596 11.213 12.2478C11.2097 12.036 11.2615 11.827 11.3635 11.6414L13.7879 7.2258Z",
    fill: "url(#paint19_radial_434_3301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M13.7879 7.2258C13.9091 7.00486 14.0875 6.82056 14.3044 6.69219C14.5213 6.56382 14.7687 6.49609 15.0207 6.49609C15.2727 6.49609 15.5201 6.56382 15.737 6.69219C15.9539 6.82056 16.1322 7.00486 16.2535 7.2258L18.6779 11.6414C18.7799 11.827 18.8317 12.036 18.8283 12.2478C18.8249 12.4596 18.7664 12.6668 18.6585 12.8491C18.5506 13.0313 18.3971 13.1823 18.2131 13.2872C18.0291 13.3921 17.8209 13.4472 17.6091 13.447H12.4322C12.2205 13.4472 12.0123 13.3921 11.8283 13.2872C11.6442 13.1823 11.4907 13.0313 11.3828 12.8491C11.275 12.6668 11.2164 12.4596 11.213 12.2478C11.2097 12.036 11.2615 11.827 11.3635 11.6414L13.7879 7.2258Z",
    fill: "url(#paint20_radial_434_3301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M13.7879 7.2258C13.9091 7.00486 14.0875 6.82056 14.3044 6.69219C14.5213 6.56382 14.7687 6.49609 15.0207 6.49609C15.2727 6.49609 15.5201 6.56382 15.737 6.69219C15.9539 6.82056 16.1322 7.00486 16.2535 7.2258L18.6779 11.6414C18.7799 11.827 18.8317 12.036 18.8283 12.2478C18.8249 12.4596 18.7664 12.6668 18.6585 12.8491C18.5506 13.0313 18.3971 13.1823 18.2131 13.2872C18.0291 13.3921 17.8209 13.4472 17.6091 13.447H12.4322C12.2205 13.4472 12.0123 13.3921 11.8283 13.2872C11.6442 13.1823 11.4907 13.0313 11.3828 12.8491C11.275 12.6668 11.2164 12.4596 11.213 12.2478C11.2097 12.036 11.2615 11.827 11.3635 11.6414L13.7879 7.2258Z",
    fill: "url(#paint21_linear_434_3301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M13.7879 7.2258C13.9091 7.00486 14.0875 6.82056 14.3044 6.69219C14.5213 6.56382 14.7687 6.49609 15.0207 6.49609C15.2727 6.49609 15.5201 6.56382 15.737 6.69219C15.9539 6.82056 16.1322 7.00486 16.2535 7.2258L18.6779 11.6414C18.7799 11.827 18.8317 12.036 18.8283 12.2478C18.8249 12.4596 18.7664 12.6668 18.6585 12.8491C18.5506 13.0313 18.3971 13.1823 18.2131 13.2872C18.0291 13.3921 17.8209 13.4472 17.6091 13.447H12.4322C12.2205 13.4472 12.0123 13.3921 11.8283 13.2872C11.6442 13.1823 11.4907 13.0313 11.3828 12.8491C11.275 12.6668 11.2164 12.4596 11.213 12.2478C11.2097 12.036 11.2615 11.827 11.3635 11.6414L13.7879 7.2258Z",
    fill: "url(#paint22_radial_434_3301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M13.7879 7.2258C13.9091 7.00486 14.0875 6.82056 14.3044 6.69219C14.5213 6.56382 14.7687 6.49609 15.0207 6.49609C15.2727 6.49609 15.5201 6.56382 15.737 6.69219C15.9539 6.82056 16.1322 7.00486 16.2535 7.2258L18.6779 11.6414C18.7799 11.827 18.8317 12.036 18.8283 12.2478C18.8249 12.4596 18.7664 12.6668 18.6585 12.8491C18.5506 13.0313 18.3971 13.1823 18.2131 13.2872C18.0291 13.3921 17.8209 13.4472 17.6091 13.447H12.4322C12.2205 13.4472 12.0123 13.3921 11.8283 13.2872C11.6442 13.1823 11.4907 13.0313 11.3828 12.8491C11.275 12.6668 11.2164 12.4596 11.213 12.2478C11.2097 12.036 11.2615 11.827 11.3635 11.6414L13.7879 7.2258Z",
    fill: "url(#paint23_radial_434_3301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M13.7879 7.2258C13.9091 7.00486 14.0875 6.82056 14.3044 6.69219C14.5213 6.56382 14.7687 6.49609 15.0207 6.49609C15.2727 6.49609 15.5201 6.56382 15.737 6.69219C15.9539 6.82056 16.1322 7.00486 16.2535 7.2258L18.6779 11.6414C18.7799 11.827 18.8317 12.036 18.8283 12.2478C18.8249 12.4596 18.7664 12.6668 18.6585 12.8491C18.5506 13.0313 18.3971 13.1823 18.2131 13.2872C18.0291 13.3921 17.8209 13.4472 17.6091 13.447H12.4322C12.2205 13.4472 12.0123 13.3921 11.8283 13.2872C11.6442 13.1823 11.4907 13.0313 11.3828 12.8491C11.275 12.6668 11.2164 12.4596 11.213 12.2478C11.2097 12.036 11.2615 11.827 11.3635 11.6414L13.7879 7.2258Z",
    fill: "url(#paint24_linear_434_3301)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    filter: "url(#filter1_f_434_3301)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M17.2726 24.5722C20.1705 24.5722 22.5198 23.4835 22.5198 22.1404C22.5198 20.7973 20.1705 19.7085 17.2726 19.7085C14.3746 19.7085 12.0254 20.7973 12.0254 22.1404C12.0254 23.4835 14.3746 24.5722 17.2726 24.5722Z",
    fill: "url(#paint25_radial_434_3301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M17.2726 24.5722C20.1705 24.5722 22.5198 23.4835 22.5198 22.1404C22.5198 20.7973 20.1705 19.7085 17.2726 19.7085C14.3746 19.7085 12.0254 20.7973 12.0254 22.1404C12.0254 23.4835 14.3746 24.5722 17.2726 24.5722Z",
    fill: "url(#paint26_radial_434_3301)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    filter: "url(#filter2_f_434_3301)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M15.7232 17.4894C18.02 17.4894 19.882 16.8237 19.882 16.0025C19.882 15.1813 18.02 14.5156 15.7232 14.5156C13.4264 14.5156 11.5645 15.1813 11.5645 16.0025C11.5645 16.8237 13.4264 17.4894 15.7232 17.4894Z",
    fill: "url(#paint27_radial_434_3301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M15.7232 17.4894C18.02 17.4894 19.882 16.8237 19.882 16.0025C19.882 15.1813 18.02 14.5156 15.7232 14.5156C13.4264 14.5156 11.5645 15.1813 11.5645 16.0025C11.5645 16.8237 13.4264 17.4894 15.7232 17.4894Z",
    fill: "url(#paint28_radial_434_3301)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    filter: "url(#filter3_f_434_3301)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M14.165 12.0201C14.8119 11.7267 16.5209 11.3311 18.1709 12.0933C17.4603 12.3229 15.6659 12.6295 14.165 12.0201Z",
    fill: "url(#paint29_linear_434_3301)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    filter: "url(#filter4_f_434_3301)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M15.5625 6.94625V12.2656H18.5175L15.5625 6.94625Z",
    fill: "url(#paint30_linear_434_3301)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_434_3301",
    x: 6.62891,
    y: 18.5593,
    width: 17.0195,
    height: 7.1626,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.234375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.351562
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.486275 0 0 0 0 0.6 0 0 0 0 0.513726 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3301"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_434_3301",
    x: 10.1504,
    y: 17.8335,
    width: 14.2441,
    height: 8.61377,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.9375,
    result: "effect1_foregroundBlur_434_3301"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_434_3301",
    x: 9.68945,
    y: 12.6406,
    width: 12.0684,
    height: 6.72363,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.9375,
    result: "effect1_foregroundBlur_434_3301"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_434_3301",
    x: 13.2266,
    y: 10.7146,
    width: 5.88281,
    height: 2.6001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.46875,
    result: "effect1_foregroundBlur_434_3301"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_434_3301",
    x: 14.625,
    y: 6.00879,
    width: 4.83008,
    height: 7.19434,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.46875,
    result: "effect1_foregroundBlur_434_3301"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_434_3301",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.1712 24.843) rotate(70.328) scale(2.84989 1.8327)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#5F2F2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F2F2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_434_3301",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.2911 24.426) rotate(102.416) scale(5.01685 2.80939)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.481,
    stopColor: "#5F2F2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.967,
    stopColor: "#5F2F2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_434_3301",
    x1: 15.0201,
    y1: 28.7011,
    x2: 14.8813,
    y2: 27.5592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B4064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B4064",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_434_3301",
    x1: 10.836,
    y1: 26.5654,
    x2: 12.1701,
    y2: 26.7183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#826C6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#826C6A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_434_3301",
    x1: 18.9163,
    y1: 26.3826,
    x2: 18.0754,
    y2: 26.7183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#826C6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#826C6A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_434_3301",
    x1: 15.0201,
    y1: 28.3692,
    x2: 15.0201,
    y2: 28.6523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5790",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F5790"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_434_3301",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.7748 22.1406) rotate(180) scale(15.4298 8.60138)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80C156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52915C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_434_3301",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0207 17.4428) rotate(90) scale(4.69794 21.2797)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57A22C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57A22C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_434_3301",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.67134 25.7218) scale(9.41306 1.49)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F779B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F779B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_434_3301",
    x1: 16.0435,
    y1: 25.9815,
    x2: 16.0435,
    y2: 25.2868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F779B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F779B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_434_3301",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.5113 18.221) rotate(173.698) scale(8.93726 2.03609)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#105B0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#105B0D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_434_3301",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.2484 16.0029) rotate(180) scale(10.432 6.13882)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80C156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52915C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_434_3301",
    x1: 10.399,
    y1: 16.0029,
    x2: 15.9537,
    y2: 16.0029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#529257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#529257",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_434_3301",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0059 12.6504) rotate(90) scale(3.35292 14.387)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57A22C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57A22C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_434_3301",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0059 18.9232) rotate(-90) scale(1.68866 8.44095)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#479820"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#479820",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_434_3301",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0059 18.6907) rotate(-90) scale(0.791016 6.97257)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15600B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15600B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_434_3301",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.6796 18.7791) rotate(-164.816) scale(11.7582 6.22912)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#75947D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75947D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_434_3301",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.1265 12.9485) rotate(90) scale(1.01075 6.93647)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15600B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15600B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_434_3301",
    x1: 13.7316,
    y1: 10.8633,
    x2: 18.1847,
    y2: 10.8633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A9D57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FC43A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_434_3301",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0207 13.7395) rotate(-90) scale(1.69922 7.55859)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B9017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B9017",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_434_3301",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.7954 13.0908) rotate(-11.411) scale(3.72332 4.42582)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#608371"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#608371",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_434_3301",
    x1: 11.2116,
    y1: 9.97174,
    x2: 12.7547,
    y2: 10.5492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#608371"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#608371",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_434_3301",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.6241 13.8699) rotate(-47.77) scale(1.20958 2.35488)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#637374"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#637374",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_434_3301",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.9219 13.9252) rotate(-4.99539) scale(4.11431 0.931343)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15600B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15600B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_434_3301",
    x1: 15.0207,
    y1: 6.49549,
    x2: 15.0207,
    y2: 7.60549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#639E52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70A960",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_434_3301",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9585 22.1404) rotate(180) scale(9.13267 1.65847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2E070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2E070",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_434_3301",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.0407 22.1404) scale(12.3254 3.78484)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.882,
    stopColor: "#9FDF6B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FDF6B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_434_3301",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.2307 16.0025) rotate(180) scale(7.23942 1.01392)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2E070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2E070",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_434_3301",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.99039 16.0025) scale(9.77034 2.3139)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.882,
    stopColor: "#9FDF6B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FDF6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_434_3301",
    x1: 17.4959,
    y1: 12.0145,
    x2: 14.3675,
    y2: 12.0145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DD573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DD573",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_434_3301",
    x1: 17.3934,
    y1: 9.73156,
    x2: 15.5719,
    y2: 10.2191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AD869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9AD869",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluentEmojiEvergreenTree);
export default __webpack_public_path__ + "static/media/fluent-emoji_evergreen-tree.d05757a4b82215605d3946260cab8a0f.svg";
export { ForwardRef as ReactComponent };